import React, { useEffect, useContext, useState,useRef, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";

const FgSaleInvoiceAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    dataPaginating,
  } = useContext(RestaurantContext);
  let { getCustomer, customerForSearch } = useContext(UserContext);
  let { foodForPOS } = useContext(FoodContext);
  const { id } = useParams();
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    branch: null,
    date: new Date(),
    customer: null,
    description: "",
    ref_no: null,
    paymentType: "cash",
  });

  const [saleInvoiceReqRef, setSaleInvoiceReqRef] = useState([]);

  //new Row
  const [newRow,setNewRow]=useState([]);

  //useEffect == componentDidMount()
  useEffect(() => {
    if(!customerForSearch){
      getCustomer();
    }
  }, []);

  const getSaleItem = async () => {
    const url = BASE_URL + "/settings/finished-good-sale-invoice/" + parseInt(id);
    setLoading(true)
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        
        const editFgSaleInvoice= res.data;
        if(editFgSaleInvoice && editFgSaleInvoice !== null){
          let docDate=new Date(editFgSaleInvoice.document_date);
          let customer={
            id: editFgSaleInvoice.customer_id,
            name: editFgSaleInvoice.customer_name
          };
         
          setNewItem({
            ...newItem,
            date: docDate,
            invoice:editFgSaleInvoice.document_identity,
            branch: editFgSaleInvoice.branch,
            ref_no: editFgSaleInvoice.ref_document_identity ? { id: null, document_identity: editFgSaleInvoice.ref_document_identity} : null,
            customer,
            paymentType:editFgSaleInvoice.payment_type,
            description:editFgSaleInvoice?.desc ?? "",
          })
          let rowArr=[];
          if(editFgSaleInvoice.finished_good_sale_invoice_detail && editFgSaleInvoice.finished_good_sale_invoice_detail.length > 0){
            editFgSaleInvoice.finished_good_sale_invoice_detail.map((item)=>{
              rowArr.push({
                item_id: item.item_id,
                item_name: item.item_name,
                qty:item.qty,
                rate: roundOffStock(item.rate),
                amount: roundOffStock(item.amount),
                discount_percent: roundOffStock(item.discount_percent),
                discount: roundOffStock(item.discount),
                tax_percent: roundOffStock(item.tax_percent),
                tax: roundOffStock(item.tax), 
                total: roundOffStock(item.total),
                isEdit:true,
              })
            })
            setNewRow([...rowArr]);
          }
        }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const getRefInfo = async (id,customer_id)=>{
    const url = BASE_URL + "/settings/get-fgso-list/" + parseInt(id) + "/" + parseInt(customer_id);
    setLoading(true)
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        
        const refNo = res.data;
        if(refNo){
          setSaleInvoiceReqRef(refNo)
        }
    } catch {
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    if(id){
      getSaleItem()
    }
  },[id])
  
  //on change input field
  const handleDesc = (e) => {
    setNewItem({ ...newItem, description: e.target.value });
  };

  const handleSetRefNo = (ref)=>{
    setNewItem({...newItem, ref_no: ref})
    if(ref.finished_good_sale_order_detail?.length){
      const items = ref.finished_good_sale_order_detail.map((item)=>{
        return {
          fgso_detail_id: item.fgso_detail_id,
          item_id: item.item_id,
          item_name: item.item_name,
          max_qty: item.remaining_qty,
          qty: item.remaining_qty,
          rate: item.price,
          amount: item.amount,
          qty: item.qty,
          tax_percent:"",
          discount_percent:"",
          isEdit: true
        }
      })
      setNewRow(items)
    }
  }

  //on change input field
  const handleChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewItem({ ...newItem, branch });
    if(branch && newItem.customer){
      getRefInfo(branch.id, newItem.customer?.id)
    }
  };

  //set items hook
  const handleSetItems = async (index,item) => {
    newRow[index].item_name=item;
    newRow[index].tax_percent="";
    newRow[index].discount_percent="";

    setNewRow([...newRow]);
  };

  //subtotal
  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index].qty !== "") {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty);
  };


  const handleTaxItem = (index) => {
    let tax = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].tax_percent !== "") {
      tax = parseFloat(newRow[index].tax_percent);
    }

    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty * (tax / 100));
  };

   // discount
   const handleDiscountItem = (index) => {
    let discount = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].discount_percent !== "") {
      discount = parseFloat(newRow[index].discount_percent);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty * (discount / 100));
  };

  //subtotal
  const handleGetSubTotal = (index) => {
    let qty = 0;
    let rate = 0;
    let tax = 0;
    let discount = 0;
    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate) {
      rate = parseFloat(newRow[index].rate);
    }
    if (newRow !== null && newRow[index].tax_percent) {
      tax = parseFloat(handleTaxItem(index));
    }
    if (newRow !== null && newRow[index].discount_percent) {
      discount = parseFloat(handleDiscountItem(index));
    }
    let amount = rate * qty;
    return roundOffStock(amount + tax - discount);
  };

  const totals = useMemo(() => {
    let totalAmount = 0;
    let totalTax = 0;
    let totalDiscount = 0;
    let baseTotal = 0

    if (newRow !== null) {
      newRow.forEach((item, index) => {
        const tax = parseFloat(handleTaxItem(index)) || 0;
        const discount = parseFloat(handleDiscountItem(index)) || 0;
        const qty = parseFloat(item.qty) || 0;
        const rate = parseFloat(item.rate) || 0;
        const baseAmount = rate * qty;
        
        baseTotal += baseAmount
        totalTax += tax;
        totalDiscount += discount;
        totalAmount += roundOffStock(baseAmount + tax - discount);
      });
    }
    return {
      baseTotal: roundOffStock(baseTotal),
      totalAmount: roundOffStock(totalAmount),
      totalTax: roundOffStock(totalTax),
      totalDiscount: roundOffStock(totalDiscount)
    };
  }, [newRow]);

  //total
  const handleGetTotal = () => {
    return roundOffStock(totals.totalAmount);
  };

  //set each item qty
  const handleItemQty = (index,e) => {
    newRow[index].qty=e.target.value;
    setNewRow([...newRow]);
  };

  //set each item rate
  const handleItemRate = (index,e) => {
    newRow[index].rate=e.target.value;
    setNewRow([...newRow]);
  };

  //set each item tax
  const handleItemTax = (index,e) => {
    newRow[index].tax_percent=e.target.value;
    setNewRow([...newRow]);
  };

  //set each item discount
  const handleItemDiscount = (index,e) => {
    newRow[index].discount_percent=e.target.value;
    setNewRow([...newRow]);
  };

  //handle Set customer hook
  const handleSetCustomer = (customer) => {
    setNewItem({ ...newItem, customer });
    if(customer && newItem.branch){
      getRefInfo(newItem.branch?.id, customer.id)
    }
  };

  //post req of food item add
  const ingredientItemAxios = async () => {
    // setLoading(true);
    let date =
      new Date(newItem.date).getFullYear() +
      "-" +
      (new Date(newItem.date).getMonth() + 1) +
      "-" +
      new Date(newItem.date).getDate();
     

    //converting items and prices to array
    let slugArray = [];
    let duplicate = {};
    const duplicateItem = [];
    newRow.map((newIngredientItem,index) => {
      const item_id = newIngredientItem.isEdit ? newIngredientItem.item_id
      : newIngredientItem.item_name.id;
      const item_name = newIngredientItem.isEdit ? newIngredientItem.item_name
        : newIngredientItem.item_name.name;
      if(duplicate[item_id]){
        duplicateItem.push({
          item_id: item_id,
          item_name: item_name,  
        })
      }
      
      if(newIngredientItem.item_name === ""){
        slugArray.push();
      }else{
        duplicate[item_id] = true;
        slugArray.push({
          qty: newIngredientItem.qty,
          price: newIngredientItem.rate,
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,
          amount: handleGetAmount(index),
          discount: handleDiscountItem(index),
          discount_percent: newIngredientItem?.discount_percent || 0,
          tax: handleTaxItem(index),
          tax_percent: newIngredientItem?.tax_percent || 0,
          total: handleGetSubTotal(index),
        });
      }
    });

    if(duplicateItem?.length){
      toast.error(`${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    let formData = {
      document_date : date,
      desc : newItem.description,
      ref_document_identity: (newItem.ref_no && newItem.ref_no?.document_identity) ?? "",
      branch_id : newItem.branch?.id,
      branch_name: newItem.branch?.name ?? "",
      customer_id : newItem.customer.id,
      customer_name: newItem.customer?.name ?? "",
      payment_type: newItem.paymentType,
      total_discount: roundOffStock(totals.totalDiscount),
      net_total: handleGetTotal(),
      total_amount: roundOffStock(totals.baseTotal),
      total_tax: roundOffStock(totals.totalTax),
      items : slugArray,
    }

    if(newRow.length === slugArray.length){
      setLoading(true);
      const mehtod = id ? "put" : "post";
      const endpoint = id ? ("/settings/finished-good-sale-invoice/" + id) : "/settings/finished-good-sale-invoice"
      const url = BASE_URL + endpoint ;
      try {
        const res = await axios[mehtod](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setLoading(false);
        toast.success(`${_t(t(id ? "Fg sale invoice has been updated" : "Fg sale invoice has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/manage/stock/fg-sale-invoice")
      } catch (error) {    
        setLoading(false);
        if(error.response.data?.status === 0){
          toast.error(`${_t(t(error.response.data?.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.error(`${_t(t("Please try again later"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }else{
      toast.error(`${_t(t("Please select all dropdowns"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.customer !== null &&
      newItem.date !== null
    ) {
      if(newRow.length>0){
        ingredientItemAxios();
      }else{
        toast.error(`${_t(t("Please add orders"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } else {
      toast.error(`${_t(t("Please fill all required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };


  const addNewRow=()=>{
    // if(newOpeningStock.branch !== null){
    setNewRow((pre)=>[...pre,{
      item_name:"",
      qty:"",
      unit:"",
      rate:"",          
      tax_percent:"",
      discount_percent:"",
      isEdit:false,
    }])
  }

  const delRow=(index)=>{
    let row=[...newRow];
    if(index > -1){
      row.splice(index, 1);
    }
    setNewRow(row);
  }

  return (
    <>
    <Helmet>
      <title>{_t(t( id ? "Edit Fg Sale Invoice" :"Add Fg Sale Invoice"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <div className={`${loading && "loading"}`}></div>
                  {/* spin loading ends */}

                  {/* Loading effect */}
                  {dataPaginating === true ? (
                    tableLoading()
                  ) : (
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t(id ? "Edit Fg Sale Invoice" : "Add Fg Sale Invoice"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                      >
                        <div className="col-12">
                          <div className="row">
                            {branchForSearch && (
                              <>                            
                                <div className="form-group col-3 mt-2">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="invoice"
                                      className="control-label"
                                    >
                                      {_t(t("Invoice #"))}
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <input
                                      disabled={true}
                                      type="text"
                                      className="form-control table-text"
                                      id="invoice"
                                      name="invoice"
                                      // onChange={handleChange}
                                      value={newItem.invoice}
                                      placeholder="Auto No"
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-3 mt-2">
                                  <div className="mb-2 ">
                                    <label
                                      htmlFor="Date"
                                      className="control-label"
                                    >
                                      {_t(t("Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={newItem.date}
                                      onChange={(date) => setNewItem({...newItem, date})}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("Purchase date"))}
                                      shouldCloseOnSelect={false}
                                    />
                                  </div>
                                </div>

                                <div className="form-group mt-3 col-3">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="paymentType"
                                      className="control-label"
                                    >
                                      {_t(t("Payment Type"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div
                                    className="mb-2 d-flex align-items-center"
                                    style={{ height: "2rem"}}
                                  >
                                    <div className="col-6 d-flex align-items-center">
                                      <input
                                        style={{fontSize:"1.2rem"}}
                                        type="radio"
                                        className="form-check-input pointer-cursor table-text"
                                        id="cash"
                                        name="paymentType"
                                        value="cash"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        checked={
                                          newItem.paymentType === "cash" ? 1 : 0
                                        }
                                      />
                                      <label
                                        className="form-radio-label pointer-cursor ml-2 mt-2"
                                        htmlFor="cash"
                                        style={{fontSize:"0.9rem"}}
                                      >
                                        {_t(t("Cash"))}
                                      </label>
                                    </div>
                                    <div className="col-6 d-flex align-items-center">
                                      <input
                                        style={{fontSize:"1.2rem"}}
                                        type="radio"
                                        className="form-check-input pointer-cursor table-text"
                                        id="credit"
                                        name="paymentType"
                                        value="credit"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        checked={
                                          newItem.paymentType === "credit" ? 1 : 0
                                        }
                                      />
                                      <label
                                        className="form-radio-label pointer-cursor ml-2 mt-2"
                                        htmlFor="credit"
                                        style={{fontSize:"0.9rem"}}
                                      >
                                        {_t(t("Credit"))}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="form-group mt-2 col-3">
                                  <div className="mb-1 text-left">
                                    <label
                                      htmlFor="branch"
                                      className="control-label text-truncate"
                                    >
                                      {_t(t("Branch"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch || []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newItem.branch || ""}
                                    classNamePrefix="select"
                                    onChange={handleSetBranch}
                                    maxMenuHeight="200px"
                                    placeholder={
                                      _t(t("Please select a branch")) + ".."
                                    }
                                    styles={customStyle}
                                    required
                                    isDisabled={id}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div className="row">
                            <div className="form-group mt-2 col-3">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="supplier"
                                  className="control-label"
                                >
                                  {_t(t("Customer"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <Select
                                options={customerForSearch || []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={newItem.customer || ""}
                                classNamePrefix="select table-text"
                                onChange={handleSetCustomer}
                                //maxMenuHeight="50px"
                                placeholder={
                                  _t(t("Please select a customer")) + ".."
                                }
                                styles={customStyle}
                                required
                                isDisabled={id}
                              />
                            </div>
                            <div className="form-group mt-2 col-2">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="supplier"
                                  className="control-label"
                                >
                                  {_t(t("Ref No"))}
                                </label>
                              </div>
                              <Select
                                options={saleInvoiceReqRef || []}
                                getOptionLabel={(option) => option?.document_identity}
                                getOptionValue={(option) => option?.id}
                                value={newItem.ref_no || ""}
                                classNamePrefix="select table-text"
                                onChange={handleSetRefNo}
                                placeholder={
                                  _t(t("Select ref no")) + ".."
                                }
                                styles={customStyle}
                                isDisabled={id}
                              />
                            </div>
                            <div className="form-group mt-2 col-7">
                              <div className="mb-2">
                                <label
                                  htmlFor="description"
                                  className="control-label"
                                >
                                  {_t(t("Description"))}
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="text"
                                  className="form-control table-text"
                                  id="description"
                                  name="description"
                                  onChange={handleDesc}
                                  value={newItem.description}
                                  placeholder="Short description"
                                />
                              </div>
                            </div>
                          </div>                          
                            <div className="table-responsive mt-3 pr-1" style={{maxHeight:"23rem",overflow: "auto"}}>
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                  {newRow.length==0 ?<th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={()=>addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                      </span>
                                    </th>:<th style={{borderBottomColor:"lightgray"}}></th>}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border "
                                      style={{minWidth:"12rem"}}
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Name"))}
                                      </span>
                                    </th>
                                  
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{minWidth:"12rem"}}
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Rate"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Amount"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Tax %"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Tax"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Discount %"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Discount"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Amount"))}
                                      </span>
                                    </th>
                                 
                                    {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}
                                  </tr>
                                </thead>
                                {newRow && newRow.length>0 ?
                                <tbody className="align-middle">
                                  {newRow.map(
                                    (ingredientItem, index) => {
                                      return (
                                        <tr
                                          className="align-middle"
                                          key={index}
                                        >
                                          <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{minWidth:"60px"}}>
                                            {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                              <i className="fa fa-plus-circle btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                            </span>}&nbsp;
                                            <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} 
                                            onClick={()=>{delRow(index)}}
                                            ></i>
                                          </td>
                                          <td className="table-text text-capitalize align-middle text-center table-Child">
                                            {ingredientItem.isEdit ?
                                              <input
                                                readOnly
                                                type="text"
                                                className={`form-control text-center table-Input table-text`}
                                                value={ingredientItem.item_name || ""}
                                              />
                                              :                                           
                                              <Select
                                                options={foodForPOS}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                classNamePrefix="select table-text"
                                                onChange={(e)=>handleSetItems(index,e)}
                                                placeholder={
                                                _t(t("Please select items")) + ".."
                                                }
                                                menuPosition="fixed"
                                                styles={customStyle}
                                              />
                                            }
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center" style={{width:"15%"}}>
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            id={ingredientItem.id}
                                            name={ingredientItem.id}
                                            onChange={(e)=>handleItemQty(index,e)}
                                            value={ingredientItem.qty}
                                            placeholder="Qty"
                                            required
                                            max={(newItem.ref_no && ingredientItem?.max_qty) ? Number(ingredientItem.max_qty) : undefined}
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center" style={{width:"15%"}}>
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            id={ingredientItem.id}
                                            name={ingredientItem.id}
                                            onChange={(e)=>handleItemRate(index,e)}
                                            value={ingredientItem.rate}
                                            placeholder="Price"
                                            required                                               
                                          />
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center">
                                         {formatPrice(handleGetAmount(index))}
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center" style={{width:"10%"}}>
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            onChange={(e)=>handleItemTax(index,e)}
                                            value={ingredientItem.tax_percent}
                                            placeholder="Tax"
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center">
                                          {formatPrice(
                                            handleTaxItem(                                                    
                                              index
                                            )
                                          )}
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center" style={{width:"10%"}}>
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            onChange={(e)=>handleItemDiscount(index,e)}
                                            value={ingredientItem.discount_percent}
                                            placeholder="Discount"
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center">
                                          {formatPrice(
                                            handleDiscountItem(                                                    
                                              index
                                            )
                                          )}
                                        </td>

                                        <td className="table-text align-middle text-center">
                                          {formatPrice(
                                            handleGetSubTotal(index)
                                          )}
                                        </td>
                                         
                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"60px"}}>
                                          <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} onClick={()=>{delRow(index)}}></i>&nbsp;
                                          {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                            <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                          </span>}                                             
                                        </td>
                                      </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                                : null }
                                {newRow && newRow.length>0 ?
                                <tfoot className="align-middle">
                                  <tr>
                                    <th
                                      scope="col"
                                      colSpan="4"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Total"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      {formatPrice(totals.baseTotal)}
                                    </th>

                                    <th></th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      {formatPrice(totals.totalTax)}
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      {formatPrice(totals.totalDiscount)}
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      {formatPrice(totals.totalAmount)}
                                    </th>
                                    
                                    {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}
                                  </tr>
                                </tfoot>  
                                : null }
                              </table>
                            </div>                            
                          <div className="form-group mt-4 pb-2">
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                type="button"
                                className="btn rounded hov-btn mr-3"
                                onClick={()=>(history.push("/dashboard/manage/stock/fg-sale-invoice"))}
                                //   data-dismiss="modal"
                                >
                                  <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                </button>                                                    
                              </div>                                                    
                          </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
  </>
  )
}

export default FgSaleInvoiceAction
